export default {
	title: "Mexico Transactions ",
	subtitle: "SPEI",
  path: "transaction_SPEI_PAYIN",
	paragraphs: [
		"SPEI is the Mexican bank transfer payment method that allows you to send and receive money almost instantly. We will open a Mexican bank account (CLABE) and associate it with your FacilitaPay internal account ID.",
		"Receiving payments via SPEI is very simple. You just need to register your customers beforehand and share with them the CLABE from the account we opened for you. Once the payment is made, we will automatically create a transaction with status identified and send you a webhook notification.",
		"Note: If you proceed without registering your customer, we won't be able to reconcile the payment, and the transaction will remain pending until you register your customer, even if they did the bank transfer."
	],
	request: {}
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionSpeiPayin.js